import type { HashtagCampaignCatalogItem } from '@/types/hashtag.types';

/** Une campañas por código; las filas de plataforma se fusionan sin duplicar `id`. */
export function mergeHashtagCampaigns(
  sources: HashtagCampaignCatalogItem[]
): HashtagCampaignCatalogItem[] {
  const byCode = new Map<string, HashtagCampaignCatalogItem>();

  for (const item of sources) {
    const code = item.hashtag_campaign_code?.trim();
    if (!code) continue;

    const existing = byCode.get(code);
    if (!existing) {
      byCode.set(code, {
        ...item,
        platforms: [...item.platforms],
      });
      continue;
    }

    const seenIds = new Set(existing.platforms.map(p => p.id));
    for (const row of item.platforms) {
      if (!seenIds.has(row.id)) {
        existing.platforms.push(row);
        seenIds.add(row.id);
      }
    }
    if (!existing.name && item.name) existing.name = item.name;
  }

  return Array.from(byCode.values()).sort((a, b) => a.name.localeCompare(b.name));
}
